<template>
  <div :class="classes" :style="overlayStyle" style="display:none"></div>
</template>

<script>
import $ from 'jquery'

export default {
  name          : 'ElementHighlighter',
  props         : {
    type        : '',
    element     : null,
    definition  : {},
    classes     : '',
    selected    : false,
    active      : false,
    disabled    : false
  },

  data() {
    return {
      identifier    : 'jbo-element-' + this._uid,
      overlay       : null,
      onclick       : null
    }
  },

  computed: {
    document() {
      return this.element.ownerDocument
    },
    '$element'() {
      return $(this.element, this.document)
    },
    overlayStyle() {
      const overlayPosition = {}
      // Necessary to keep this style reactive
      const classList       = this.classes
      
      const $target = $(this.element, this.document)
      const position= { ...$target.offset(), height: $target.outerHeight(), width: $target.outerWidth() }
      const $range  = $target.is('.anchor-to-span') && $target.children().not('.jbo-overlay').length
        ? $target.children().not('.jbo-overlay')
        : $target
      
      $range.each((i, el) => {
        const $el     = $(el)
        const $op     = $el.offsetParent()
        const offset  = (this.element.tagName !== 'IMG' || $range == $target)
          ? $el.position()
          : { left: 0, top: 0 }
        const pos     = { ...$el.offset(), height: $el.outerHeight(), width: $el.outerWidth() }

        // If element is entirely inside its container, don't include it in the overlay
        if (this.element.tagName !== 'IMG' && 
            position.left <= pos.left && position.left + position.width >= pos.left + pos.width && 
            position.top <= pos.top && position.top + position.height >= pos.top + pos.height)
          return

        Object.assign(overlayPosition, {
          left    : Math.min(overlayPosition.left || 99999999999, offset.left + $op.scrollLeft() + parseInt($el.css('margin-left'))),
          top     : Math.min(overlayPosition.top || 99999999999, offset.top + $op.scrollTop() + parseInt($el.css('margin-top'))),
          width   : Math.max(overlayPosition.width || 0, $el.outerWidth()),
          height  : Math.max(overlayPosition.height || 0, $el.outerHeight())
        })
      })

      return {
        width       : overlayPosition.width + 'px',
        height      : overlayPosition.height + 'px',
        left        : overlayPosition.left + 'px',
        top         : overlayPosition.top + 'px',
        position    : 'absolute',
        'z-index'   : $target.css('z-index')
      }
    }
  },
  
  mounted() {
    this.updateOverlay()
  },
  updated() {
    this.updateOverlay()
  },
  beforeDestroy() {
    this.overlay.off('click', this.click).fadeOut(300, () => {
      this.overlay.remove()
    })
    this.$element.off('click', this.click).removeClass(this.classFilter)
    this.element.onclick = this.onclick
  },
  
  watch: {
    overlayStyle() {
      this.updateOverlay()
    },
  },
  methods: {
    click(ev) {
      if (!this.disabled) {
        ev && (ev.preventDefault(), ev.stopImmediatePropagation())
        this.$parent.$emit('click', this.$parent, $(ev.target, this.document))
      }
    },
    classFilter(index, name) {
      return (name.match(/(^|\s)jbo\S+/g) || []).join(' ')
    },
    updateOverlay() {
      this.overlay = $('.' + this.identifier, this.document)
      
      // Overlay not yet present, add it now
      if (!this.overlay.length) {
        const voidNodes     = new RegExp("^(AREA|BASE|BR|COL|COMMAND|EMBED|HR|IMG|INPUT|KEYGEN|LINK|META|PARAM|SOURCE|TRACK|WBR)$")
        const element       = this.element
        const isVoid        = voidNodes.test(element.nodeName)
        const mount         = isVoid? element.parentNode: element
        const nextElement   = isVoid? element.nextSibling: element.firstChild
        const span          = document.createElement('var')

        // Attach the definition to this object for easy referencing
        span.jbo_definition = this.definition
        
        // Insert overlay in the first stacking context greater than `element`
        nextElement
          ? mount.insertBefore(span, nextElement)
          : mount.appendChild(span)
        
        this.overlay = $(span).click(this.click).hide().fadeIn(300)
        this.$element.click(this.click)
        
        // Disable onclick events if the overlay is active 
        this.onclick         = this.element.onclick
        this.element.onclick = (ev) => this.disabled && this.onclick && this.onclick.apply(this.element, arguments)
      }
      
      this.overlay.css({ ...this.overlayStyle, display: 'inline-block' }).attr('class', this.identifier + ' ' + this.classes)

      if (this.element.tagName !== 'IMG')
        this.$element.removeClass(this.classFilter).addClass(this.classes)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ElementHighlighter.vue?0b9da8ec